import { Component, OnInit } from '@angular/core';
import { RequestService } from 'src/app/services/request.service';
import { Details } from 'src/app/intefaces/details.interface';
import { InfoDetails } from 'src/app/intefaces/infoDetails.interface';
import { customerRequest } from 'src/app/intefaces/customerRequest.interface';
import { Loan } from 'src/app/intefaces/loan.interface';
import { Reference } from 'src/app/intefaces/references.interface';
import { CustomerUpdate } from 'src/app/intefaces/customerUpdate.interface';
import { Financial } from 'src/app/intefaces/financial.interface';
import { RequestUpdate } from 'src/app/intefaces/requestUpdate.interface';
import swal from 'sweetalert2';
import { Router } from '@angular/router';
import { Financials } from 'src/app/intefaces/financials.interface';
import { UsersService } from 'src/app/services/users.service';
import * as AWS from 'aws-sdk';
import { String } from 'aws-sdk/clients/appstream';
import { UploadService } from 'src/app/upload.service';
import { WebsocketService } from 'src/app/services/webSocket.service';
// 25274335
import { trigger,
  state,
  style,
  animate,
  transition} from '@angular/animations'
declare const $: any;
@Component({
  selector: 'app-assignment',
  templateUrl: './assignment.component.html',
  styleUrls: ['./assignment.component.css'],
  animations:[
    trigger("fadeInOut", [
      state(
        "void",
        style({
          opacity: 0
        })
      ),
      transition("void <=> *", animate(1000))
    ]),
    // trigger("EnterLeave", [
    //   state("flyIn", style({ transform: "translateX(0)" })),
    //   transition(":enter", [
    //     style({ transform: "translateX(-100%)" }),
    //     animate("0.5s 300ms ease-in")
    //   ]),
    //   transition(":leave", [
    //     animate("0.3s ease-out", style({ transform: "translateX(100%)" }))
    //   ])
    // ])
  ]
})
export class AssignmentComponent implements OnInit {
  colorsWelliStatus = [{label:'Aprobado',classButton:'btn-success'},{label:'Desembolsado',classButton:'btn-study'},{label:'Negado',classButton:'btn-danger'},{label:'En estudio',classButton:'btn-warning'},{label:'Desistió ',classButton:'btn-dismissed'},{label:'Crédito Firmado',classButton:'btn-pending'}]
  StatusSelect = {
    label:'Aprobado',classButton:'btn-success'
  }
  statusSelectCredi = {
    label:'Aprobado',classButton:'btn-success'
  }
  dateNow  = new Date();
  details:Details = {
    userId:'',
    loanId: '',
    customerId: ''
  }
  customer:customerRequest= {
    activity: '',
    address: '',
    anotherIncome: '',
    birthday: '',
    city: '',
    customerId: '',
    district: '',
    documentDate: '',
    documentId: 0,
    documentType: '',
    email: '',
    gender: '',
    income: 0,
    names: '',
    phone: 0 ,
    surnames: '',
    timestamp: 0,
    cusAddressState:'',
    cusMaritalStatus:'',
    cusEducationLevel:''
  }
  loan:Loan = {
    requestAmount: 0,
    rate: 0,
    discount: 0,
    total: 0,
    time: 0,
    clinic: '',
    observations: '',
    files:[],
    userId: '',
    createdBy: '',
    financial: [],
    patients :[]
  }
  financials:Financials[] = [];
  info:InfoDetails= {
    Customer:this.customer,
    Loan:this.loan
    
  };
  referenceOne:Reference = {
    name:'',
    surname:'',
    phone:'',
    relationship:''
  }
  referenceTwo:Reference = {
    name:'',
    surname:'',
    phone:'',
    relationship:''
  }
  references:Reference[] = [];
  customerUpdate:CustomerUpdate = {
    birthplace:'',
    customerId:'',
    names: '',
    surnames: '',
    gender: '',
    documentId: 0,
    documentType: '',
    documentDate: '',
    birthday: '',
    phone: 0,
    email: '',
    activity: '',
    income: 0,
    anotherIncome: 0,
    address: '',
    city: '',
    district: '',
    housingType: '',
    housingTime: 0,
    dependents: 0,
    health: '',
    ciio: '',
    references:this.references,
    cusMaritalStatus:'',
    cusEducationLevel:'',
    cusAddressState:{},
    cusAddressCity:{},
    cusLaborContract:'',
    LaborAntiquity:'',
    EconomicLevel:'',
    HousingType:'',
    NumDependents:'',
    LaborContract:'',
    treatments:'',
    outcome:''

  }
  financial:Financial = {
    financialName: '',
    status: '',
    incident: '',
    delivery: '',
    billing: '',
    amount: 0,
    observations: '',
    userId: 'NA',
    userName : '',
    files:[],
    code: ''
  }

  requestUpdate:RequestUpdate ={
    loanId: '',
    customerId: '',
    userId: 'NA',
    financial: this.financial
  }
  bodyWelli = {
 
    phone_number: '',
    name: '',
    last_name: '',
    email: '',
    economic_activity: '',
    date_of_birth: '',
    document_type: '',
    document: '',
    amount:  0,
    institution: '',
    clinicZone:'',
    patients:[],
    user:'',
    createdBy:''
  }
  infoWelli = {
    initCreate: '',
    status:'',
    approve:0,
    plazo: '',
    cuota:0,
    url:'',
    coutas:[],
    coutasObj: [],
    

  }
  bodyCrediFamilia ={
    name:"Pedro",
    last_name:"Ficticio",
    document_type:"CC",
    document:1234567890,
    date_of_birth:"25/04/1990",
    phone_number:"3103198250",
    email:"pedro@test.com",
    income:5000000,
    other_income:5000000,
    economic_activity:"Empleado",
    entry_date:"25/04/2020",
    country:"Colombia",
    payment_day:16,
    rate:1,
    requestId:"",
    clinic:""
 }
 infoCredi = {
  message:"",
  transactionId:"",
  transaction_hash:"",
	status: 0,
	plazo: 0,
	status_detail: "",
	valor_disponible_para_comprar: 0,
	fianza_anticipada: 0,
	total_a_financiar: 0,
	total_primera_cuota: 0,
	cuota_capital_mas_interes: 0,
	seguro_vida_mensual: 0,
	total_cuota_mensual: 0,
  url:''
 }

 infoMedi = {
  customerStatus: "",
  idCustomer : "",
  creditLimit: {
    result: "",
    creditLimit: 0,
    dateCreated: "",
    dateExpiration: "",
    resultDetailInternal: "",
    resultDetailCustomer: null

    },
    ofertas:{
      tasaCero:[],
      tasaNormal:[]
    }
 }

  mensajeButtonMedi = {
    mensaje:'Cargando',
    boton:'btn-warning',
    infoAd: 'Cliente debe completar el el registro.'
  };
  cuotaActive = {
    id: '',
    active: true 
  }
  typeCouta= {
     id: '0',
    active: true 
  }
  centinelaCuotaActiveMeddi = [];
  centinelaCoutaMeddi = {
    idActive:'',
    label:'',
    valorMes:0
  }
  asi = false;
  fina:string[] = ['Addi','MEDDIPAY','WELLI','Servicredito','CREDIFAMILIA','Sistecredito','Brilla','CRECECOL'];
  status:string[] = ['Aprobado', 'Pendiente', 'Negado', 'Anulado', 'Desembolsado'];
  flag = false;
  pro = localStorage.getItem('pro');

  users:any[] = [];
  type= '';
  banderaUs = false;
  asignarUsuario = '';
  usuarioEsta = ''
  usu =  localStorage.getItem('iux');
  files:any[]= [];
  viewFiles:any = [];
  upCc:any;
  filesBitacora:any = [];
  banderaAd1 = false;
  filesProb:any = [];
  obsProb = '';
  urlProb = '';
  idWelliGet = 'ea182a72-bcac-43c9-bf0b-8b42f373257e'
  flagWelli = false;
  errorWelli = false;
  msgErrorWelli = ''
  mostrarWelliResponse = false;
  fechaError =  new Date();

  flagCredi = false;
  errorCredi = null;
  confirmarCrediFamilia = null;
  flagConfirmacion = false
  msgErrorCrdi = '';
  mostarCrediResponse = false;
  fechaErrorCredi = new Date();
  ocultarCargando = false;
  mensajeStatusCrediFamilia = ''
  activarWelli = false;
  activarCredi = false;
  activarMedi = false;
  activarMediCoutas = false;
  errorPostMedi = {
    bandera: false,
    mensaje:'Error'
  }
  mostrarMensajeInvitacion = false
  mostrarErrorMensajeInvitacion = {bandera:false, mensaje:'Error'}
  centinelaStatusCouta = {
    couta:'',
    tasa:''
  }

  contactos = [
    {
      type:'WA',
      value:'WhatsApp'
    },
    {
      type:'SMS',
      value:'Mensaje de texto'
    },
    {
      type:'EMA',
      value:'Correo electrónico'
    }
]
  tipoContacto= '';

  constructor(private requestServices:RequestService, private router:Router,private userServices: UsersService ,private uploadServices:UploadService ) { 
    // this.WebsocketService.messages.subscribe(msg => {
    //   // this.received.push(msg);
      
    // });
    this.details = this.requestServices.getDetails();
    this.usuarioEsta = this.details.userId + '';
    this.details.userId = 'NA';
    if(this.usuarioEsta == 'NA' && this.pro != 'Comercial' ){
      //llamar ws
      // this.webSocketOn();
      this.details.userId = this.usu + '';
    //   $.notify({
    //     icon: 'notifications',
    //    message: "Solicitudes sin Asignar fue actualizado.",
    //   }, {
    //    type: 'warning',
    //    timer: 1000,
    //    placement: {
    //        from: 'top',
    //        align: 'right'
    //    },
    //    template: '<div data-notify="container" class="col-xs-11 col-sm-3 alert alert-{0} alert-with-icon" role="alert">' +
    //    '<button mat-raised-button type="button" aria-hidden="true" class="close" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
    //    '<i class="material-icons" data-notify="icon">notifications</i> ' +
    //    '<span data-notify="title">{1}</span> ' +
    //    '<span data-notify="message">{2}</span>' +
    //    '<div class="progress" data-notify="progressbar">' +
    //      '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
    //    '</div>' +
    //    '<a href="{3}" target="{4}" data-notify="url"></a>' +
    //  '</div>'
    //   })
    }
    this.requestServices.postDetails(this.details).subscribe((data:any) =>{

      this.info= data;
   
      this.files = this.info.Loan.files;
      this.customerUpdate.activity = this.info.Customer.activity;
      this.customerUpdate.address = this.info.Customer.address;
      this.customerUpdate.anotherIncome = Number( this.info.Customer.anotherIncome);
      this.customerUpdate.birthday = this.info.Customer.birthday;
      this.customerUpdate.city = this.info.Customer.city;
      this.customerUpdate.customerId = this.info.Customer.customerId;
      this.customerUpdate.district = this.info.Customer.district;
      this.customerUpdate.documentDate = this.info.Customer.documentDate;
      this.customerUpdate.documentId = this.info.Customer.documentId;
      this.customerUpdate.documentType = this.info.Customer.documentType;
      this.customerUpdate.email = this.info.Customer.email;
      this.customerUpdate.gender = this.info.Customer.gender;
      this.customerUpdate.income = this.info.Customer.income;
      this.customerUpdate.names = this.info.Customer.names;
      this.customerUpdate.phone = this.info.Customer.phone;
      this.customerUpdate.surnames = this.info.Customer.surnames;

      this.customerUpdate.cusMaritalStatus = this.info.Customer.cusMaritalStatus;
      this.customerUpdate.cusEducationLevel = this.info.Customer.cusEducationLevel;
      this.customerUpdate.cusAddressState = this.info.Customer.cusAddressState;
      this.customerUpdate.cusAddressCity = this.info.Customer.cusAddressCity;
      this.customerUpdate.cusLaborContract = this.info.Customer.cusLaborContract;
      this.customerUpdate.LaborAntiquity = this.info.Customer.LaborAntiquity;
      this.customerUpdate.EconomicLevel = this.info.Customer.EconomicLevel;
      this.customerUpdate.HousingType = this.info.Customer.HousingType;
      this.customerUpdate.NumDependents = this.info.Customer.NumDependents;
      this.customerUpdate.LaborContract = this.info.Customer.LaborContract;
      this.customerUpdate.treatments = this.info.Customer.treatments;
      this.customerUpdate.outcome = this.info.Customer.outcome
     

      this.customerUpdate = data.Customer;
   
      this.financials = this.info.Loan.financial;
     
    
      this.bodyWelli.phone_number= this.customerUpdate.phone + '',
      this.bodyWelli.name= this.customerUpdate.names,
      this.bodyWelli.last_name= this.customerUpdate.surnames,
      this.bodyWelli.email= this.customerUpdate.email,
      this.bodyWelli.economic_activity= this.customerUpdate.activity,
      this.bodyWelli.date_of_birth= this.customerUpdate.birthday,
      this.bodyWelli.document_type= this.customerUpdate.documentType,
      this.bodyWelli.document = this.customerUpdate.documentId + '',
      this.bodyWelli.amount=  this.info.Loan.requestAmount,
      this.bodyWelli.institution= this.info.Loan.clinic,
      this.bodyWelli.clinicZone =this.info.Loan.clinicZone + ''
      this.bodyWelli.patients = this.info.Loan.patients 
      this.bodyWelli.createdBy = this.info.Loan.createdBy
      this.bodyWelli.user = localStorage.getItem('usu')
      
  
      this.bodyCrediFamilia.name = this.customerUpdate.names
      this.bodyCrediFamilia.last_name = this.customerUpdate.surnames
      this.bodyCrediFamilia.document_type = this.customerUpdate.documentType
      this.bodyCrediFamilia.document = this.customerUpdate.documentId
      this.bodyCrediFamilia.date_of_birth = this.customerUpdate.birthday.split('T')[0]
      this.bodyCrediFamilia.phone_number = this.customerUpdate.phone + ''
      this.bodyCrediFamilia.email = this.customerUpdate.email
      this.bodyCrediFamilia.income = this.customerUpdate.income
      this.bodyCrediFamilia.other_income = this.customerUpdate.anotherIncome
      this.bodyCrediFamilia.economic_activity = this.customerUpdate.activity
      this.bodyCrediFamilia.rate = this.info.Loan.rate
      this.bodyCrediFamilia.requestId = this.details.loanId
      this.bodyCrediFamilia.clinic = this.info.Loan.clinic

      let fechaCentinela =  this.bodyCrediFamilia.date_of_birth.split('-')
      let fechaRealCredi =  fechaCentinela[2]+'/'+ fechaCentinela[1] + '/' + fechaCentinela[0]
      this.bodyCrediFamilia.date_of_birth  = fechaRealCredi;
      this.financials
      
      this.financials.splice(0,1);
      
      // for(let i =0;i< this.financials.length;i++){
      //     for(let j =0;j< this.financials[i].files.length; j++){
      //         this.getFileBitacora(this.financials[i].files[j]);
      //     }
      //     this.financials[i].files = this.filesBitacora;
      //     //  this.getFileBitacora(this.financials[i]);
      //     this.filesBitacora = [];
      // }
      // console.log(this.financials);
     for(let i = 0; i < this.files.length; i++){

        this.getFile(this.files[i]);


     }
     console.log(this.files.length)
      if(this.customerUpdate.references.length !=0){

        this.referenceOne = this.customerUpdate.references[0];
        this.referenceTwo = this.customerUpdate.references[1];
        
        
        this.flag = true;
       
      }
      // this.sendWelliInfo()
      // this.sendInfoCredi()
    })
    

  }
  consultarWelli(){
    this.activarWelli = true;
     this.sendWelliInfo()
     
  }
  consultarCredi(){
    this.activarCredi = true
    this.sendInfoCredi()
  }
  consultarMedi(){
    this.activarMedi = true
    this.sendInfoMeddi();
  }
  actualizarConsultaCrediFamilia(){
    this.updateCredi(this.details.loanId)
  }
  updateMedi(){
    let bodyGet = {
      cusDocumentType: this.customerUpdate.documentType,
      cusDocument: this.customerUpdate.documentId,
      idPos: this.info.Loan.clinic,
      amountFinance:this.info.Loan.requestAmount + '',
    }
    this.requestServices.getInfoMeddi(bodyGet).subscribe((dataGet:any)=>{
      this.activarMediCoutas = true;
      this.infoMedi.ofertas = dataGet.ofertas
      if(dataGet.statusCliente){
           this.infoMedi.customerStatus = dataGet.statusCliente
      }
      if(dataGet.data.customerStatus){
        this.infoMedi.customerStatus = dataGet.data.customerStatus
      }
   
       
     
      if(dataGet.creditLimitResult){
        this.infoMedi.creditLimit = dataGet.data.creditLimitResult
       
      }
      if(this.infoMedi.creditLimit.result == 'DEN'){
        this.infoMedi.customerStatus = 'NEGADO'
      }
      this.activateTypeCouta('0');
      this.mostrarMensaje(this.infoMedi.customerStatus)
    })
    this.dateNow =new Date();
  }
  updateCredi(id){
    let body = {
      requestId: id
    }

    this.requestServices.getAllInfoCredi(body).subscribe((data:any) =>{
      console.log(data)
      this.infoCredi.status = data.status;
      console.log(this.infoCredi.status)
      if(this.infoCredi.status == null){
        this.mensajeStatusCrediFamilia  = 'Actualizar consulta'
        this.confirmarCrediFamilia = true;
        this.flagConfirmacion = false;
        this.ocultarCargando = true;
      }else{
        if(this.infoCredi.status === 1 || this.infoCredi.status ==  2 ||  this.infoCredi.status == 4){
          this.confirmarCrediFamilia = true;
          this.flagConfirmacion = false;
          this.ocultarCargando = true;
          this.mensajeStatusCrediFamilia  = 'Actualizar consulta'
        }
        else{

          this.confirmarCrediFamilia= false;
          this.flagConfirmacion = true
          this.flagCredi =true;
          this.infoCredi.valor_disponible_para_comprar = data.valor_disponible_para_comprar;
          this.infoCredi.plazo = data.plazo;
          this.infoCredi.total_a_financiar = data.total_a_financiar;
          this.infoCredi.total_primera_cuota = data.total_primera_cuota;
          this.infoCredi.total_cuota_mensual = data.total_cuota_mensual;
          this.infoCredi.cuota_capital_mas_interes = data.cuota_capital_mas_interes;
          this.infoCredi.fianza_anticipada = data.fianza_anticipada;
          this.infoCredi.seguro_vida_mensual = data.seguro_vida_mensual;
          this.infoCredi.url =  data.url
          this.infoCredi.status_detail = data.status_detail;
          this.statusSelectCredi.label = data.status_detail;
          if(this.statusSelectCredi.label == 'RECHAZADO'){
            this.statusSelectCredi.classButton = 'btn-danger';
          }
        }


      }
    },(error)=>{
      console.log(error)
    })
  }

  sendInfoMeddi(){
    if(!this.customerUpdate.cusAddressState){
      console.log('este en el error')
        $.notify({
        icon: 'notifications',
       message: "Los información requerída para Meddipay no está completa, cree una nueva solicitud",
      }, {
       type: 'warning',
       timer: 1000,
       placement: {
           from: 'top',
           align: 'right'
       },
       template: '<div data-notify="container" class="col-xs-11 col-sm-3 alert alert-{0} alert-with-icon" role="alert">' +
       '<button mat-raised-button type="button" aria-hidden="true" class="close" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
       '<i class="material-icons" data-notify="icon">notifications</i> ' +
       '<span data-notify="title">{1}</span> ' +
       '<span data-notify="message">{2}</span>' +
       '<div class="progress" data-notify="progressbar">' +
         '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
       '</div>' +
       '<a href="{3}" target="{4}" data-notify="url"></a>' +
     '</div>'
      })
          this.activarMedi = false
    }else{

      let nombres = this.customerUpdate.names.split(' ')
      let apellidos = this.customerUpdate.surnames.split(' ')
    
      let body = {
        cusDocumentType: this.customerUpdate.documentType,
        cusDocument: this.customerUpdate.documentId,
        cusFirstName: nombres[0],
        cusSecondName: nombres[1] ? nombres[1] : '',
        cusFirstSurname: apellidos[0],
        cusSecondSurname: apellidos[1] ? apellidos[1] : '',
        cusBirthDate: this.customerUpdate.birthday.split('T')[0],
        cusGender: this.customerUpdate.gender,
        cusEmail: this.customerUpdate.email,
        cusPhone: this.customerUpdate.phone,
        cusAddressState: this.customerUpdate.cusAddressState.nombre,
        cusAddressCity: this.customerUpdate.cusAddressCity.nombre,
        cusAddress: this.customerUpdate.address,
        cusEconomicLevel: this.customerUpdate.EconomicLevel,
        cusMaritalStatus: this.customerUpdate.cusMaritalStatus,
        cusEducationLevel:  this.customerUpdate.cusEducationLevel,
        cusHousingType:this.customerUpdate.HousingType,
        cusNumDependents: this.customerUpdate.NumDependents,
        cusLaborType: this.customerUpdate.activity,
        cusLaborCompany: this.customerUpdate.district,
        cusLaborContract: this.customerUpdate.LaborContract,
        cusLaborAntiquity: this.customerUpdate.LaborAntiquity,
        cusLaborSalary: this.customerUpdate.income,
        cusTotalExpenses: this.customerUpdate.outcome,
        idPos: this.info.Loan.clinic,
        amountFinance:this.info.Loan.requestAmount + '',
      }
      console.log(body)
      this.errorPostMedi.bandera = false;
      this.requestServices.saveRequestMeddi(body).subscribe((data:any)=>{
        if(data){
          let bodyGet = {
            cusDocumentType: this.customerUpdate.documentType,
            cusDocument: this.customerUpdate.documentId,
            idPos: this.info.Loan.clinic,
            amountFinance:this.info.Loan.requestAmount + '',
          }
          if(data.data.creditLimitResult){
            if(data.data.creditLimitResult.result == 'DEN'){
              this.infoMedi.customerStatus = 'NEGADO';
              this.mostrarMensaje(this.infoMedi.customerStatus)
            }else{
              this.requestServices.getInfoMeddi(bodyGet).subscribe((dataGet:any)=>{
                this.activarMediCoutas = true;
                this.infoMedi.ofertas = dataGet.ofertas
                
                if(dataGet.statusCliente){
                  console.log('en el estado')
                    this.infoMedi.customerStatus = dataGet.statusCliente
                }
                if(dataGet.data){
                  this.infoMedi.customerStatus = dataGet.data.customerStatus
                }
                if(dataGet.cupoAprobado){
                  this.infoMedi.creditLimit.creditLimit = dataGet.cupoAprobado
                
                }
                if(this.infoMedi.creditLimit.result == 'DEN'){
                  this.infoMedi.customerStatus = 'NEGADO'
                }
                this.activateTypeCouta('0');
                this.mostrarMensaje(this.infoMedi.customerStatus)
              },(error)=>{
                this.activarMedi = false
                  this.errorPostMedi.bandera = true;
                  this.errorPostMedi.mensaje = "Valide información y reenvié la solicitud"
                  console.log(this.errorPostMedi)
              })

            }
          }else{
            this.requestServices.getInfoMeddi(bodyGet).subscribe((dataGet:any)=>{
                this.activarMediCoutas = true;
                this.infoMedi.ofertas = dataGet.ofertas
                
                if(dataGet.statusCliente){
                  console.log('en el estado')
                    this.infoMedi.customerStatus = dataGet.statusCliente
                }
                if(dataGet.data){
                  this.infoMedi.customerStatus = dataGet.data.customerStatus
                }
                if(dataGet.cupoAprobado){
                  this.infoMedi.creditLimit.creditLimit = dataGet.cupoAprobado
                
                }
                if(this.infoMedi.creditLimit.result == 'DEN'){
                  this.infoMedi.customerStatus = 'NEGADO'
                }
                this.activateTypeCouta('0');
                this.mostrarMensaje(this.infoMedi.customerStatus)
              },(error)=>{
                this.activarMedi = false
                  this.errorPostMedi.bandera = true;
                  this.errorPostMedi.mensaje = "Valide información y reenvié la solicitud"
                  console.log(this.errorPostMedi)
              })
          }
        
        }
      },(error) =>{
        console.log(error)
        this.activarMedi = false
        this.errorPostMedi.bandera = true;
        this.errorPostMedi.mensaje = error.error.message.message
        console.log(this.errorPostMedi)
      })
    }
  }

  enviarSolicitud(){
      let treatments = 0;
      switch(this.customerUpdate.treatments){
        case 'Ortodoncia':
          treatments = 6;
          break
        case 'Endodoncia':
          treatments = 13;
          break
        case 'Periodoncia':
          treatments = 14;
          break
        case 'Rehabilitación':
          treatments = 20;
          break
        case 'Implantología':
          treatments = 26;
          break
        default :
           treatments = 0;
            break  
      }

    let centinelaType = [];
    let body={
      idPos: this.info.Loan.clinic,
      documentType: this.customerUpdate.documentType + '',
      document: this.customerUpdate.documentId + '',
      financingRate: this.centinelaStatusCouta.tasa,
      amountTreatment: this.info.Loan.requestAmount + '',
      amountFinance: this.info.Loan.requestAmount + '',
      treatment: treatments,
      ...(this.tipoContacto !== '' && {
        notificationType:[this.tipoContacto]
      } )
      
    }
   


    this.requestServices.sendInvitation(body).subscribe(data =>{
      console.log(data)
      this.mostrarMensajeInvitacion  =true
      this.mostrarErrorMensajeInvitacion.bandera  =false
    }, (error)=>{
      this.mostrarErrorMensajeInvitacion.bandera  =true;
      this.mostrarErrorMensajeInvitacion.mensaje  =error.error.message.message;
    })

  } 
  mostrarMensaje(mensaje:any){
    console.log(mensaje)
    switch(mensaje){
        case 'NO_REQUEST':
          this.mensajeButtonMedi.mensaje = 'Pendiente de Aprobación';
          this.mensajeButtonMedi.boton = 'btn-pending';
          break
        case 'IN_PROCESS':
          this.mensajeButtonMedi.mensaje = 'Validación en curso';
          this.mensajeButtonMedi.boton = 'btn-warning';
          break
        case 'CALCULATED':
          this.mensajeButtonMedi.mensaje = 'Aprobado';
          this.mensajeButtonMedi.boton = 'btn-success';
          break
        case 'CREDIT_EXPIRED':
          this.mensajeButtonMedi.mensaje = 'Cupo vencido';
          this.mensajeButtonMedi.boton = 'btn-danger';
          break
        case  'NEGADO':
          this.mensajeButtonMedi.mensaje = 'Negado';
          this.mensajeButtonMedi.boton = 'btn-danger';
          break
        default:
          this.mensajeButtonMedi.mensaje = 'Error';
          this.mensajeButtonMedi.boton = 'btn-danger';
    }
  }
  sendInfoCredi(){
  //   let mock = {
  //      message:"",
  //     transactionId:"",
  //     transaction_hash:"",
  //     status: null,
  //     plazo: 0,
  //     status_detail: "",
  //     valor_disponible_para_comprar: 0,
  //     fianza_anticipada: 0,
  //     total_a_financiar: 0,
  //     total_primera_cuota: 0,
  //     cuota_capital_mas_interes: 0,
  //     seguro_vida_mensual: 0,
  //     total_cuota_mensual: 0
  //   }
  //   this.infoCredi = mock
  //  this.updateCredi(this.details.loanId)
  console.log(this.bodyCrediFamilia)
    this.requestServices.saveRequestCredi(this.bodyCrediFamilia).subscribe((data:any) =>{
      console.log(data)
      this.infoCredi =data;
      // this.flagCredi =true;
      this.updateCredi(this.details.loanId)
      // this.setInfoCredi();
    },(error)=>{

      // this.updateCredi(this.details.loanId)
      this.fechaError  = new Date()
      console.log('esta en el error')
      this.mostarCrediResponse = true;
      this.errorCredi = true;
      this.msgErrorCrdi =  error.message;
    })
  }
  setInfoCredi(){
   
    switch (this.infoCredi.message){
      case "Solicitud encolada con éxito.":
        this.statusSelectCredi = this.colorsWelliStatus[0]
        break
      case "rejected":
        this.statusSelectCredi = this.colorsWelliStatus[2]
        break
      // case "desembolsado":
      //   this.StatusSelect = this.colorsWelliStatus[1]
      //   break
      // case "pendiente_aprobacion_medico":
      //   this.StatusSelect = this.colorsWelliStatus[3]
      //   this.StatusSelect.label = "Pendiente de solicitud"
      //   break
      // case "dismissed":
      //   this.StatusSelect = this.colorsWelliStatus[4]
       
      //   break
      // case "pendiente_desembolso":
      //   this.StatusSelect = this.colorsWelliStatus[5]
       
      //   break
      default:
        this.statusSelectCredi = this.colorsWelliStatus[3]
    }
  }
  goWelli(){
    window.open(
      this.infoWelli.url, "_blank");
  }
  goCrediFamilia(){
     window.open(
      this.infoCredi.url, "_blank");
  }
  sendWelliInfo(){
    this.bodyWelli.date_of_birth =  this.bodyWelli.date_of_birth.split('T')[0]
    this.bodyWelli.document+= '';

   
    this.requestServices.saveRequestWelli(this.bodyWelli).subscribe((data:any) =>{
      this.mostrarWelliResponse = true;
      this.setInfoWelli(data.data)
      this.flagWelli = true;
      this.errorWelli = false;
    },(error)=>{
      this.fechaError  = new Date()
      console.log('esta en el error')
      this.mostrarWelliResponse = true;
      this.errorWelli = true;
      this.msgErrorWelli =  error.message;

    })
  }
  setInfoWelli(data){
    
    this.infoWelli.status = data.estado
    switch (this.infoWelli.status){
      case "approved":
        this.StatusSelect = this.colorsWelliStatus[0]
        break
      case "rejected":
        this.StatusSelect = this.colorsWelliStatus[2]
        break
      case "desembolsado":
        this.StatusSelect = this.colorsWelliStatus[1]
        break
      case "pendiente_aprobacion_medico":
        this.StatusSelect = this.colorsWelliStatus[3]
        this.StatusSelect.label = "Pendiente de solicitud"
        break
      case "dismissed":
        this.StatusSelect = this.colorsWelliStatus[4]
       
        break
      case "pendiente_desembolso":
        this.StatusSelect = this.colorsWelliStatus[5]
       
        break
      default:
        this.StatusSelect = this.colorsWelliStatus[3]
    }

    this.infoWelli.coutas = Object.keys(data.plan_de_cuotas)
      
      
    if(this.infoWelli.coutas.length !== 0){
      this.infoWelli.plazo = '0'
      this.infoWelli.coutasObj = Object.values(data.plan_de_cuotas);

    }else{
      this.infoWelli.coutas = []
      
      this.infoWelli.plazo = '0'
      this.infoWelli.coutasObj = []
    }
    
    // let x = Object.values(data.plan_de_cuotas)[0] as any 
   this.infoWelli.cuota = 0
    this.infoWelli.approve = data.monto_aprobado
    this.infoWelli.initCreate =data.fecha_creacion
    this.infoWelli.url = data.next_step_url
    this.idWelliGet = data.id
    if(this.infoWelli.coutas.length !== 0){

      this.activeCouta('0')
    }
   
  }
  getInfoWelli(){
    this.requestServices.getRequestWelli(this.idWelliGet).subscribe((data:any) =>{
     
      this.setInfoWelli(data.data)
      this.dateNow = new Date();
      this.activeCouta('0')
    
    })
  }
  activateTypeCouta(index:string){
    this.typeCouta.id = index
    if(this.typeCouta.id == '0'){
        this.centinelaCuotaActiveMeddi = this.infoMedi.ofertas.tasaCero
        this.centinelaStatusCouta.tasa = 'DENTISALUD_NO_INT'
      

    }else{
      this.centinelaCuotaActiveMeddi = this.infoMedi.ofertas.tasaNormal
        this.centinelaStatusCouta.tasa = 'NODISC_CUSRISKINT'
    }
    this.activeCoutaMeddi('0')
    
  }
   activeCoutaMeddi(index:string){
    this.centinelaCoutaMeddi.idActive = index;
 
    this.centinelaCoutaMeddi.label = this.centinelaCuotaActiveMeddi[index].label
    this.centinelaCoutaMeddi.valorMes = this.centinelaCuotaActiveMeddi[index].valorMes;
  }
  activeCouta(index:string){
    this.cuotaActive.id = index
    let centinelaWelli = this.infoWelli.coutasObj [index]
    this.infoWelli.cuota = centinelaWelli.cuota_asignacion
    this.infoWelli.plazo = this.infoWelli.coutas[index]
  }
  updateWelli(){

    this.dateNow = new Date();
    let elementSelect = Math.floor(Math.random() * this.colorsWelliStatus.length)
    this.StatusSelect = this.colorsWelliStatus[elementSelect];
  }
  recargar(){
    $('#save').attr("disabled", false);
    const jumbo = document.querySelector('.jumbo');
    jumbo.scrollIntoView({behavior: 'smooth'});
    this.financial = {
      financialName: '',
      status: '',
      incident: '',
      delivery: '',
      billing: '',
      amount: 0,
      observations: '',
      userId: 'NA',
      userName : '',
      files:[],
      code: ''
    }
    this.details = this.requestServices.getDetails();
    console.log("aca esta la recarga");
    console.log(this.details);
    this.usuarioEsta = this.details.userId;
    this.details.userId = 'NA';
   
    this.requestServices.postDetails(this.details).subscribe((data:any) =>{
      console.log(data);
      this.info= data;
      console.log(this.info);
      this.files = this.info.Loan.files;
      this.customerUpdate.activity = this.info.Customer.activity;
      this.customerUpdate.address = this.info.Customer.address;
      this.customerUpdate.anotherIncome = Number( this.info.Customer.anotherIncome);
      this.customerUpdate.birthday = this.info.Customer.birthday;
      this.customerUpdate.city = this.info.Customer.city;
      this.customerUpdate.customerId = this.info.Customer.customerId;
      this.customerUpdate.district = this.info.Customer.district;
      this.customerUpdate.documentDate = this.info.Customer.documentDate;
      this.customerUpdate.documentId = this.info.Customer.documentId;
      this.customerUpdate.documentType = this.info.Customer.documentType;
      this.customerUpdate.email = this.info.Customer.email;
      this.customerUpdate.gender = this.info.Customer.gender;
      this.customerUpdate.income = this.info.Customer.income;
      this.customerUpdate.names = this.info.Customer.names;
      this.customerUpdate.phone = this.info.Customer.phone;
      this.customerUpdate.surnames = this.info.Customer.surnames;
      console.log(this.customerUpdate);
      console.log(this.info);
      this.customerUpdate = data.Customer;
      console.log(this.customerUpdate);
      console.log(this.customerUpdate.references[1]);
      this.financials = this.info.Loan.financial;
      


      console.log(this.financials);
      
      this.financials
      
      this.financials.splice(0,1);
      
      // for(let i =0;i< this.financials.length;i++){
      //     for(let j =0;j< this.financials[i].files.length; j++){
      //         this.getFileBitacora(this.financials[i].files[j]);
      //     }
      //     this.financials[i].files = this.filesBitacora;
      //     //  this.getFileBitacora(this.financials[i]);
      //     this.filesBitacora = [];
      // }
      // console.log(this.financials);
     for(let i = 0; i < this.files.length; i++){

        this.getFile(this.files[i]);


     }
     console.log(this.files.length)
      if(this.customerUpdate.references.length !=0){

        this.referenceOne = this.customerUpdate.references[0];
        this.referenceTwo = this.customerUpdate.references[1];
        
        
        this.flag = true;
        console.log("si tiene");
      }
    })


  }
  ngOnInit() {
  }
  saveBitacora(obse:string, adj:string[]){
    this.obsProb = obse;
    this.filesProb = adj;
    console.log(this.filesProb);
    AWS.config.credentials = new AWS.Credentials({
      accessKeyId: 'AKIA4CWZSJBUFPQPPFF5', secretAccessKey: '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'
    });
    const params = {
      Bucket: 'dev.alivio.bucket',
      Key: this.filesProb[0]
    };
    let s3 = new AWS.S3();
    s3.getSignedUrl('getObject',params, (err, url) =>{
      if(err){
        console.log(err);
      }else{
        console.log("aca esta la url");
        console.log(url);
        this.filesProb[0] = url;
      }
    })
    s3.getObject(params, function(err, data) {
      if (err) {
        console.error(err); // an error occurred
      } else {
        console.log("aca esta el serivicio get de el file")
        console.log(data);
        // const fil = new TextDecoder('utf-8').decode(data);
        // console.log(file);
      }
    });
  }

  getFileBitacora(file:string){
    AWS.config.credentials = new AWS.Credentials({
      accessKeyId: 'AKIA4CWZSJBUFPQPPFF5', secretAccessKey: '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'
    });
    const params = {
      Bucket: 'dev.alivio.bucket',
      Key: file
    };
    let s3 = new AWS.S3();
    s3.getSignedUrl('getObject',params, (err, url) =>{
      if(err){
        console.log(err);
      }else{
        console.log("aca esta la url");
        console.log(url);
        this.filesBitacora.push(url);
      }
    })
    s3.getObject(params, function(err, data) {
      if (err) {
        console.error(err); // an error occurred
      } else {
        console.log("aca esta el serivicio get de el file")
        console.log(data);
        // const fil = new TextDecoder('utf-8').decode(data);
        // console.log(file);
      }
    });

  }
  getFile(file:String){
      // Set up credentials
      AWS.config.credentials = new AWS.Credentials({
        accessKeyId: 'AKIA4CWZSJBUFPQPPFF5', secretAccessKey: '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'
      });
      const params = {
        Bucket: 'dev.alivio.bucket',
        Key: file
      };
      let s3 = new AWS.S3();
      s3.getSignedUrl('getObject',params, (err, url) =>{
        if(err){
          console.log(err);
        }else{
          console.log("aca esta la url");
          console.log(url);
          this.viewFiles.push(url);
        }
      })
      s3.getObject(params, function(err, data) {
        if (err) {
          console.error(err); // an error occurred
        } else {
          console.log("aca esta el serivicio get de el file")
          console.log(data);
          // const fil = new TextDecoder('utf-8').decode(data);
          // console.log(file);
        }
      });


  }

  onChange(event:any) {
    let file:File = event.target.files[0];
    this.upCc = file;
    console.log(file);
    console.log("entro")
    console.log(event.target.files);
    this.banderaAd1 = true;
    // this.upCc = event.target.files;
  }

  openFile(u:string){
    window.open(u);
  }
  openFiles(num:any){
    console.log(this.viewFiles[num]);
    // window.open(u);
  }
  update(){

    console.log(this.flag)
    if(this.flag){
      this.customerUpdate.references[0] = this.referenceOne;
      this.customerUpdate.references[1] = this.referenceTwo;
      console.log(this.customerUpdate.references);

    }
    else{
      this.customerUpdate.references.push(this.referenceOne);
      this.customerUpdate.references.push(this.referenceTwo);
      console.log(this.customerUpdate);
    }

    


    this.requestServices.putCustomer(this.customerUpdate).subscribe((data:any) =>{
      console.log(data);
      $.notify({
        icon: 'notifications',
       message: data,
      }, {
       type: 'success',
       timer: 1000,
       placement: {
           from: 'top',
           align: 'right'
       },
      })


    });

  }
  tipo(){
    this.userServices.getUsers(this.type).subscribe((data:any)=>{
      console.log(data);
      this.users= data;
      this.banderaUs = true;
     
    })
  }
  async  save(){
    $('#save').attr("disabled", true);
    
    this.requestUpdate.customerId = this.customerUpdate.customerId;
    this.requestUpdate.loanId = this.details.loanId;
    this.financial.userName = localStorage.getItem('usu') + '';
    this.requestUpdate.financial = this.financial;
    if(this.banderaAd1){
      let url;
      url = await this.uploadServices.fileUpload(this.upCc);
      console.log(url);
      //this.request.Loan.files.push(url);
      console.log(this.requestUpdate.financial.files)
      
    }
    if(this.asi){
      this.requestUpdate.financial.userId = localStorage.getItem('iux') + '';
      console.log(this.requestUpdate.financial.userId);
      this.requestUpdate.userId = localStorage.getItem('iux') + '';
    }
    
    console.log("esta es la info enviada")
    console.log(this.requestUpdate);
    this.requestUpdate.userId = localStorage.getItem('iux') + '';
    if(this.asi){
      console.log("entro")
      console.log(this.asignarUsuario);
      this.requestUpdate.userId = this.asignarUsuario 
    }
    if(this.requestUpdate.financial.status == 'Negado' ){
      if(this.requestUpdate.financial.financialName == '' || 
      this.requestUpdate.financial.amount == 0 ||
      this.requestUpdate.financial.code == '' 
      ){
        $('#save').attr("disabled", false);
          swal({
            title: "Validacion incorrecta",
            text: "campos obligatorios por diligenciar!",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-success",
            type: "warning"
           
        })
      }else {
        this.requestUpdate.financial.files= this.uploadServices.getFiles();
        this.uploadServices.setFiles();
        console.log(this.requestUpdate.financial.files);
        this.requestServices.putLoan(this.requestUpdate).subscribe((data:any) =>{
          console.log(data);
          console.log('');
          swal({
            title: "Solicitud guardada",
            text: "",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-success",
            type: "success",
            onAfterClose: () => this.recargar()
        }).catch(swal.noop)
    
        })
      }
      
    }else{

      if(this.requestUpdate.financial.financialName == '' || 
        this.requestUpdate.financial.status == '' ||
        this.requestUpdate.financial.incident == '' ||
        this.requestUpdate.financial.delivery == '' ||
        this.requestUpdate.financial.billing == '' ||
        this.requestUpdate.financial.amount == 0 ||
        this.requestUpdate.financial.code == '' 
        ){
          $('#save').attr("disabled", false);
          swal({
            title: "Validacion incorrecta",
            text: "campos obligatorios por diligenciar!",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-success",
            type: "warning"
           
        })
  
      }else{
        
        this.requestUpdate.financial.files= this.uploadServices.getFiles();
        this.uploadServices.setFiles();
        console.log(this.requestUpdate.financial.files);
        this.requestServices.putLoan(this.requestUpdate).subscribe((data:any) =>{
          console.log(data);
          console.log('');
          swal({
            title: "Solicitud guardada",
            text: "",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-success",
            type: "success",
            onAfterClose: () => this.recargar()
        }).catch(swal.noop)
    
        })
      }
    }


}
}
